/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Travel_StartInputs */

const en_ticket_action_travel_start = /** @type {(inputs: Ticket_Action_Travel_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travel Start`)
};

const ja_ticket_action_travel_start = /** @type {(inputs: Ticket_Action_Travel_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移動開始`)
};

const fr_ticket_action_travel_start = /** @type {(inputs: Ticket_Action_Travel_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer le trajet`)
};

const de_ticket_action_travel_start = /** @type {(inputs: Ticket_Action_Travel_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfahrt starten`)
};

/**
* | output |
* | --- |
* | "Travel Start" |
*
* @param {Ticket_Action_Travel_StartInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_travel_start = /** @type {((inputs?: Ticket_Action_Travel_StartInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Travel_StartInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_travel_start(inputs)
	if (locale === "ja") return ja_ticket_action_travel_start(inputs)
	if (locale === "fr") return fr_ticket_action_travel_start(inputs)
	return de_ticket_action_travel_start(inputs)
});